'use strict';

var SELECTOR_SHIPPING_BLOCK_WARNING = '.shipping-block-warning';
var SELECTOR_DELIVERY_CONTAINERS = '.checkout-button, .minicart-footer';

/**
* Updates the promotions list in a discount section by removing existing ones and adding new ones
* @param {jQuery} $container - jQuery element that contains the promotions list
* @param {Array} newPromotions - Array of promotion objects containing id, calloutMsg and details
*/
function updateCartSummaryPromotions($container, newPromotions) {
    $container.empty();

    newPromotions.forEach(promotion => {
        $container.append(`
            <div class="discount-item" data-promotion-id="${promotion.id}">
                <div class="discount-title">${promotion.calloutMsg}</div>
                <div class="discount-description">${promotion.details}</div>
            </div>
        `);
    });
}


/**
* Updates a discount section in the cart summary with new data and promotions
* @param {string} type - Type of discount section ('product', 'shipping' or 'order')
* @param {Object} discountData - Object containing value and formatted price
* @param {Array} promotions - Array of promotions to display in the section
*/
function updateCartSummaryDiscounts($section, discountData, promotions) {
    if (discountData.value !== 0) {
        $section.removeClass('d-none');
        var discountFormattedValue = `-$${Math.abs(discountData.value).toFixed(2)}`;

        $section.find('.discount-value').empty().append(discountFormattedValue);
        updateCartSummaryPromotions($section.find('.discount-details'), promotions);
    } else {
        $section.addClass('d-none');
    }
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    $('.number-of-items').empty().append(data.resources.numberOfItems);
    $('.minicart-quantity').empty().append(data.numItems);
    $('.minicart-link').attr({
        'aria-label': data.resources.minicartCountOfItems,
        title: data.resources.minicartCountOfItems
    });

    if (data.totals) {
        $('.subtotal-section .summary-value').empty().append(data.totals.subTotal);
        $('.minicart-footer-total-value.sub-total').empty().append(data.totals.grandTotalWithoutShippingCost);

        updateCartSummaryDiscounts($(`.product-discount-section`), data.totals.productDiscounts, data.totals.categorizedPromotions.product);

        $('.shipping-section .summary-value').empty().append(data.totals.totalShippingCost);

        updateCartSummaryDiscounts($(`.shipping-discount-section`), data.totals.shippingLevelDiscountTotal, data.totals.categorizedPromotions.shipping);
        updateCartSummaryDiscounts($(`.order-discount-section`), data.totals.orderLevelDiscountTotal, data.totals.categorizedPromotions.order);

        $('.grand-total').empty().append(data.totals.grandTotal);

        const $savingsRow = $('.savings-row');
        if (data.totals.totalSavings.value) {
            $savingsRow.removeClass('d-none');
            $savingsRow.find('.savings-value').empty()
                .append(data.totals.totalSavings.formatted);
        } else {
            $savingsRow.addClass('d-none');
        }
    }

    if (data.shippingBlockState) {
        updateShippingBlockState(data.shippingBlockState);
    }

    data.items.forEach(function (item) {
        var $promoContainer = $('.item-' + item.UUID);
        $promoContainer.empty();

        if (item.promotions && item.promotions.length > 0) {
            var promo = item.promotions[0]

            if (promo.calloutMsg && promo.calloutMsg.length > 0) {
                var promoHtml = `
                    <div class="promotions">
                        <div class="promo-badge">
                            ${promo.calloutMsg}
                        </div>
                    </div>
                `;
                $promoContainer.append(promoHtml);
            }
        }
        $('.uuid-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
        $('.line-item-price-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
        $('.item-total-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
    });

    updateFreeShippingWidget(data);
}

/**
 * re-renders the free shipping widget (message, progress bar, state).
 * Uses class selectors so both the cart and the mini cart instances update.
 * @param {Object} data - AJAX response containing the CartModel (with freeShippingProgress)
 */
function updateFreeShippingWidget(data) {
    if (!data || !data.freeShippingProgress) {
        return;
    }

    var widget = data.freeShippingProgress;
    var $widget = $('.free-shipping-widget');

    if (!$widget.length) {
        return;
    }

    if (widget.state === 'hidden') {
        $widget.addClass('d-none');
        return;
    }

    $widget.removeClass('d-none');
    $widget.find('.free-shipping-widget-text').empty().append(widget.message);
    $widget.find('.free-shipping-widget-bar-fill').css('width', widget.percentage + '%');
    $widget.find('.free-shipping-widget-check').toggleClass('d-none', widget.state !== 'achieved');
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
    var html = '';
    $('.approaching-discounts').empty();
    if (approachingDiscounts.length > 0) {
        approachingDiscounts.forEach(function (item) {
            html += '<div class="single-approaching-discount text-center">'
                + item.discountMsg + '</div>';
        });
    }
    $('.approaching-discounts').append(html);
}

/**
 * Guarantees that every valid container has a .shipping-block-warning child.
 * Creates empty nodes only; content and visibility are handled by renderShippingBlockWarning.
 *
 * Uses structural anchor discovery ($container.find('a, button')) instead of
 * surface-specific selectors, keeping the function agnostic of Cart vs Mini Cart.
 *
 * @param {jQuery} $containers - potential parent elements
 */
function ensureShippingBlockWarning($containers) {
    $containers.each(function () {
        var $container = $(this);
        if ($container.children(SELECTOR_SHIPPING_BLOCK_WARNING).length) return;

        var $anchor = $container.find('a, button').first();
        var $el = $('<div class="shipping-block-warning"></div>');
        if ($anchor.length) {
            $el.insertBefore($anchor);
        } else {
            $container.prepend($el);
        }
    });
}

/**
 * Updates all existing warning elements with the pre-built HTML.
 * When warningHtml is empty, hides all instances (shipping is unblocked).
 *
 * Operates on the full jQuery collection — no iteration needed since
 * html(), show() and hide() apply identically to every matched element.
 *
 * @param {string} warningHtml - pre-built warning inner HTML (empty = hidden)
 */
function renderShippingBlockWarning(warningHtml) {
    var $warnings = $(SELECTOR_SHIPPING_BLOCK_WARNING);
    if (!warningHtml) {
        $warnings.hide();
        return;
    }
    $warnings.html(warningHtml).show();
}

/**
 * Toggles the disabled class and data attribute on all checkout buttons.
 *
 * @param {boolean} blocked - whether shipping is currently blocked
 */
function updateCheckoutButtons(blocked) {
    var $btns = $('.checkout-btn');
    $btns.data('shipping-blocked', blocked);
    $btns.toggleClass('disabled', blocked);
}

/**
 * Orchestrates shipping block state UI updates across all surfaces.
 * Builds warningHtml once and reuses it across all surfaces.
 * Surface-agnostic: any template that includes shippingBlockWarning.isml
 * is automatically supported via SELECTOR_DELIVERY_CONTAINERS.
 *
 * @param {Object} shippingBlockState - shipping block state from CartModel
 */
function updateShippingBlockState(shippingBlockState) {
    if (!shippingBlockState) return;

    // El mensaje es HTML configurable en BM: puede venir vacio o con marcado sin
    // texto (ej. "<p></p>"). Se comprueba el texto real para no pintar un
    // recuadro de advertencia vacio.
    var hasWarningText = shippingBlockState.warningMessage
        && $('<div>').html(shippingBlockState.warningMessage).text().trim().length > 0;

    var warningIconUrl = $('.checkout-button, .minicart-content').data('warning-icon-url');
    var warningHtml = hasWarningText
        ? '<img loading="lazy" src="' + warningIconUrl
            + '" alt="warning" />' + shippingBlockState.warningMessage
        : '';

    ensureShippingBlockWarning($(SELECTOR_DELIVERY_CONTAINERS));
    renderShippingBlockWarning(warningHtml);
    updateCheckoutButtons(shippingBlockState.blocked);
}

module.exports = {
    updateCartTotals: updateCartTotals,
    updateApproachingDiscounts: updateApproachingDiscounts,
    updateShippingBlockState: updateShippingBlockState,
    updateFreeShippingWidget: updateFreeShippingWidget
};
